import { IPaymentDetailOptions } from "./paymentIntent";

export interface IProps {
  orderId: string;
  paymentDetailsOptions: IPaymentDetailOptions | null;
}

export interface IBillingDetails {
  cardholderName: string;
  email: string;
}

export type CardType = "national" | "international";

export const defaultBillingDetails: IBillingDetails = {
  cardholderName: "",
  email: "",
};

export const getErrorMessage = (error_code: string) => {
  switch (error_code) {
    case "card_declined":
      return "Your card was declined. Please try a different card.";
    case "expired_card":
      return "Your card has expired. Please use a different card.";
    case "incorrect_cvc":
      return "The CVC code you entered is incorrect. Please check and try again.";
    case "incorrect_number":
      return "The card number you entered is incorrect. Please check and try again.";
    case "incorrect_zip":
      return "The ZIP/postal code is incorrect. Please double-check your billing address.";
    case "invalid_cvc":
      return "The CVC code is invalid. Please try again.";
    case "invalid_expiry_month":
      return "The expiration month is invalid. Please check and try again.";
    case "invalid_expiry_year":
      return "The expiration year is invalid. Please check and try again.";
    case "invalid_number":
      return "The card number is invalid. Please try a different card.";
    case "insufficient_funds":
      return "Your card has insufficient funds. Please use a different card or check with your bank.";
    case "authentication_required":
      return "Your card requires additional authentication. Please follow the instructions or use another card.";
    case "processing_error":
      return "An error occurred while processing your card. Please try again or use another payment method.";
    case "try_again_later":
      return "Something went wrong. Please try again later or use a different card.";
    case "payment_intent_authentication_failure":
      return "Authentication failed. Please try again or use a different card.";
    default:
      return "Your card couldn’t be processed. Please try another card or contact your bank.";
  }
};
